const MOENGAGE_APP_ID = process.env.MOENGAGE_APP_ID || process.env.REACT_APP_MOENGAGE_APP_ID;
const debug_logs = process.env.MOENGAGE_DEBUG || process.env.REACT_APP_MOENGAGE_DEBUG;

let Moengage = {
  track_event : ()=> {},
  add_user_attribute : ()=> {},
  add_first_name : ()=> {},
  add_last_name : ()=> {},
  add_email : ()=> {},
  add_mobile : ()=> {},
  add_user_name : ()=> {},
  add_gender : ()=> {},
  add_birthday : ()=> {},
  destroy_session : ()=> {},
  add_unique_user_id : ()=> {},
  moe_events : ()=> {},
  call_web_push : ()=> {},
  track : ()=> {},
  location_type_attribute : ()=> {}
}

const loadMO = () =>{
     (function (i, s, o, g, r, a, m, n) {
        i.moengage_object = r;
        let t = {};
        let f=[];
        let h={};
        let q = function (f) {
          return function () {
            (i.moengage_q = i.moengage_q || []).push({ f: f, a: arguments });
          };
        };
        // eslint-disable-next-line
        (f = [
          'track_event',
          'add_user_attribute',
          'add_first_name',
          'add_last_name',
          'add_email',
          'add_mobile',
          'add_user_name',
          'add_gender',
          'add_birthday',
          'destroy_session',
          'add_unique_user_id',
          'moe_events',
          'call_web_push',
          'track',
          'location_type_attribute'
        ]),
        // eslint-disable-next-line
          (h = { onsite: ['getData','registerCallback'] });
        // eslint-disable-next-line
        for (let k in f) {
        // eslint-disable-next-line
          t[f[k]] = q(f[k]);
        }

        for(let k in h){
          for(let l in h[k]){
            null==t[k]&&(t[k]={}),t[k][h[k][l]]=q(k+"."+h[k][l])
          }
        }

        a = s.createElement(o);
        m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
        i.moe =
          i.moe ||
          function () {
            n = arguments[0];
            return t;
          };

        a.onload = function () {
          if (n) {
            // eslint-disable-next-line
            i[r] = moe(n);
          }
        };
      })
      (window, document, 'script', 'https://cdn.moengage.com/webpush/moe_webSdk.min.latest.js', 'Moengage');

}


const initialize = () =>{
    loadMO();
    setTimeout(()=>{
      Moengage = window.moe({
        app_id: String(MOENGAGE_APP_ID),
        debug_logs: debug_logs,
        swPath: "/service-worker.js"
      });
    }, 1000);
}

const setUserId = id => {
  Moengage.add_unique_user_id(id);
  !id && logout();
}

const setUserProperty = (params, value) => Moengage.add_user_attribute(params, value);

const registerProperty = (params,value) =>{
  switch(params){
    case "email" :
          setEmail(value);
       break;
    case "phone" :
          setMobile(value);
       break;
    case "first_name" :
          setFirstName(value);
       break;
    case "last_name" :
          setLastName(value);
       break;
  }
}

const registerProperties = propertyObject => {
  for (const key in propertyObject) {
      if (propertyObject.hasOwnProperty(key)) {
        registerProperty(key, propertyObject[key]);
      }
    }
}

const logEvent = (event, params) => {
  Moengage.track_event(event, params);
}

const logout = () => Moengage.destroy_session();

const setFirstName = firstName => Moengage.add_first_name(firstName);

const setLastName = lastName => Moengage.add_last_name(lastName);

const setEmail = email => Moengage.add_email(email);

const setMobile = mobile => Moengage.add_mobile(mobile);

const setGender = gender => Moengage.add_gender(gender);

export default {
    initialize,
    setUserId,
    setUserProperty,
    logEvent,
    logout,
    setFirstName,
    setLastName,
    setEmail,
    setMobile,
    setGender,
    registerProperties
}
